import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import GuestPostDisplayCard from "../helper/GuestPostDisplayCard";
import { createGuestSessionStart } from "../../store/actions/PostAction";
import { Col, Container } from "react-bootstrap";
import SpinnerLoader from "../Loader/SpinnerLoader";

const GuestPostView = (props) => {

  useEffect(() => {
    if (props.guestPost.loading)
      if (localStorage.getItem("guestToken") && localStorage.getItem("guestToken") != "") {
        props.dispatch(
          createGuestSessionStart({
            post_unique_id: props.match.params.post_unique_id,
            guest_token: localStorage.getItem("guestToken") || ""
          })
        );
      } else {
        props.dispatch(
          createGuestSessionStart({
            post_unique_id: props.match.params.post_unique_id
          })
        );

      }

  }, []);

  return (
    <div className="home-screen home-sec">
      <Container>
        <div className="padding-top-xl">
          <Col xl={9} offset={2} md={9} className="custom-padding">
            {props.guestPost.loading ? (
              <SpinnerLoader />
            ) : (
              <GuestPostDisplayCard
                post={props.guestPost.data.post}
                key={props.guestPost.data.post.post_unique_id}
              />
            )}
          </Col>
        </div>
      </Container>
    </div>
  );
};

const mapStateToPros = (state) => ({
  guestPost: state.post.guestPost,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(GuestPostView);
